import { RootState, useAppSelector } from "../../../../src/app/store";
import React from "react";

interface FeatureGateProps {
  selector: (state: RootState) => boolean;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const FeatureGate: React.FC<FeatureGateProps> = ({
  selector,
  children,
  fallback = null,
}) => {
  const isEnabled = useAppSelector(selector);

  if (!isEnabled) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default FeatureGate;
